import styles from './index.module.scss';
const CircleArrow = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles['circle-arrow']}
    >
      <defs>
        <clipPath id="bgblur_0_3083_984_clip_path" transform="translate(4.2 4.2)">
          <path d="M24 3.5C12.6782 3.5 3.5 12.6782 3.5 24C3.5 35.3218 12.6782 44.5 24 44.5C35.3218 44.5 44.5 35.3218 44.5 24C44.5 12.6782 35.3218 3.5 24 3.5Z" />
        </clipPath>
      </defs>
      <foreignObject x="-4.2" y="-4.2" width="56.4" height="56.4">
        <div
          style={{
            backdropFilter: 'blur(3.6px)',
            clipPath: 'url(#bgblur_0_3083_984_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <path
        data-figma-bg-blur-radius="7.2"
        d="M24 3.5C12.6782 3.5 3.5 12.6782 3.5 24C3.5 35.3218 12.6782 44.5 24 44.5C35.3218 44.5 44.5 35.3218 44.5 24C44.5 12.6782 35.3218 3.5 24 3.5Z"
        fill="white"
        className={styles['circle-arrow-ring']}
      />
      <path d="M26.52 31.0595L19.48 23.9995L26.52 16.9395" fill="white" />
      <path
        d="M26.52 31.0595L19.48 23.9995L26.52 16.9395"
        className={styles['circle-arrow-icon']}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleArrow;
